// import { useState, useRef } from "react";
// import "./MultipleDragDropImage.css";
// import uploadIcon from "../assets/upload-icon1.svg";
// import { apiUrl } from "../utils/apis";

// export default function MultipleDragDropImage({ fetchMediaFiles }) {
//   const [uploadingCount, setUploadingCount] = useState(0); // track active uploads
//   const fileInputRef = useRef(null);

//   const handleFiles = (newFiles) => {
//     Array.from(newFiles).forEach((file) => {
//       uploadFile(file);
//     });
//   };

//   const uploadFile = (file) => {
//     setUploadingCount((prev) => prev + 1); // increment when upload starts

//     const formData = new FormData();
//     formData.append("file", file);

//     const xhr = new XMLHttpRequest();
//     xhr.open("POST", apiUrl + "/api/media/media?type=1");
//     xhr.setRequestHeader(
//       "Authorization",
//       `Bearer ${localStorage.getItem("token")}`
//     );

//     xhr.onload = () => {
//       setUploadingCount((prev) => prev - 1); // decrement when finished
//       if (xhr.status === 200) {
//         if (fetchMediaFiles) fetchMediaFiles();
//       } else {
//         console.error("Upload failed", xhr.responseText);
//       }
//     };

//     xhr.onerror = () => {
//       setUploadingCount((prev) => prev - 1);
//       console.error("Upload error");
//     };

//     xhr.send(formData);
//   };

//   const handleDrop = (e) => {
//     e.preventDefault();
//     handleFiles(e.dataTransfer.files);
//   };

//   const handleBrowse = (e) => {
//     handleFiles(e.target.files);
//   };

//   return (
//     <div
//       className={`dropzone ${uploadingCount > 0 ? "disabled" : ""}`}
//       onDrop={handleDrop}
//       onDragOver={(e) => e.preventDefault()}
//       onClick={() => fileInputRef.current.click()}
//     >
//       <img src={uploadIcon} alt="Upload" className="upload-icon" />
//       <div className="uploadtxt">
//         {uploadingCount > 0
//           ? `Uploading ${uploadingCount} file(s)...`
//           : <>Drag and drop images, videos or <span>Click to Browse</span></>}
//       </div>
//       <input
//         type="file"
//         multiple
//         accept="image/*,video/*"
//         ref={fileInputRef}
//         onChange={handleBrowse}
//         style={{ display: "none" }}
//       />
//     </div>
//   );
// }

import { useState, useRef } from "react";
import "./MultipleDragDropImage.css";
import uploadIcon from "../assets/upload-icon1.svg";
import { apiUrl } from "../utils/apis";
import { toast } from "react-toastify";
import axios from "axios";

export default function MultipleDragDropImage({ fetchMediaFiles }) {
  const [files, setFiles] = useState([]);
  const [uploading, setUploading] = useState(false);
  const fileInputRef = useRef(null);

  const handleFiles = (newFiles) => {
    const mapped = Array.from(newFiles).map((file) => ({
      file,
      preview: URL.createObjectURL(file),
      progress: 0,
    }));

    setFiles(mapped);
    uploadFiles(mapped);
  };

  //   const uploadFiles = (fileList) => {
  //     setUploading(true);

  //     const formData = new FormData();
  //     fileList.forEach((f) => formData.append("file", f.file));

  //     const xhr = new XMLHttpRequest();
  //     xhr.open("POST", apiUrl + "/api/media/media?type=1");
  //     xhr.setRequestHeader(
  //       "Authorization",
  //       `Bearer ${localStorage.getItem("token")}`
  //     );

  //     // total progress across all files
  //     xhr.upload.onprogress = (event) => {
  //       if (event.lengthComputable) {
  //         const percent = Math.round((event.loaded / event.total) * 100);
  //         setFiles((prev) =>
  //           prev.map((item) => ({
  //             ...item,
  //             progress: percent, // same progress for all (since one request)
  //           }))
  //         );
  //       }
  //     };

  //     xhr.onload = () => {
  //       setUploading(false);
  //       if (xhr.status === 200) {
  //         setFiles((prev) =>
  //           prev.map((item) => ({ ...item, progress: 100 }))
  //         );
  //         if (fetchMediaFiles) fetchMediaFiles();
  //       } else {
  //         console.error("Upload failed", xhr.responseText);
  //       }
  //     };

  //     xhr.onerror = () => {
  //       setUploading(false);
  //     };

  //     xhr.send(formData);
  //   };

  const uploadFiles = async (fileList) => {
    setUploading(true);

    const token = localStorage.getItem("token");

    try {
      // Upload each file separately with its own progress
      await Promise.all(
        fileList.map((f) => {
          const formData = new FormData();
          formData.append("file", f.file);

          return axios.post(apiUrl + "/api/media/media?type=2", formData, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
            onUploadProgress: (progressEvent) => {
              if (progressEvent.total) {
                const percent = Math.round(
                  (progressEvent.loaded * 100) / progressEvent.total
                );
                setFiles((prev) =>
                  prev.map((item) =>
                    item.file === f.file ? { ...item, progress: percent } : item
                  )
                );
              }
            },
          });
        })
      );

      setFiles((prev) => prev.map((item) => ({ ...item, progress: 100 })));
      if (fetchMediaFiles) fetchMediaFiles();
    } catch (error) {
      console.log(error, "l");
      let message = "File upload failed. Please try again.";

      if (error.response) {
        if (error.response.status === 413) {
          message = "File is too large. Please upload a smaller file.";
        } else {
          message = error.response.data?.message || message;
        }
      } else if (error.request) {
        message = error.message;
      } else {
        message = error.message;
      }

      toast.error(message);
    } finally {
      setUploading(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    handleFiles(e.dataTransfer.files);
  };

  const handleBrowse = (e) => {
    handleFiles(e.target.files);
  };

  const formatFileSize = (bytes) => {
    if (bytes === 0) return "0 B";
    const k = 1024;
    const sizes = ["B", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${(bytes / Math.pow(k, i)).toFixed(1)} ${sizes[i]}`;
  };

  const isUploading = uploading && files.some((f) => f.progress < 100);

  return (
    <div className="multi-upload-container">
      {isUploading ? (
        <div className="uploading-box">
          <h4 className="uploadingtext">Uploading...</h4>
          {files.map((f, i) => (
            <div key={i} className="upload-progress">
              <div className="file-info">
                <div className="filename">{f.file.name}</div>
                <div className="file-size">{formatFileSize(f.file.size)}</div>
              </div>
              <div className="progress-bar">
                <div
                  className="progress"
                  style={{ width: `${f.progress}%` }}
                ></div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div
          className="dropzone"
          onDrop={handleDrop}
          onDragOver={(e) => e.preventDefault()}
          onClick={() => fileInputRef.current.click()}
        >
          <img src={uploadIcon} alt="Upload" className="upload-icon" />
          <div className="uploadtxt">
            Drag and drop images, videos or <span>Click to Browse</span>
          </div>
          <input
            type="file"
            multiple
            accept="image/*,video/*"
            ref={fileInputRef}
            onChange={handleBrowse}
            style={{ display: "none" }}
          />
        </div>
      )}
    </div>
  );
}
